import React from 'react';
import './ShutterText.scss';

function ShutterText({ text }) {
  return (
    <div className="shutter-wrapper">
      <div id="ui">
        {Array(40).fill(null).map((a, index) => <div key={index} className="text">{text}</div>)}
      </div>
    </div>
  );
}

export default ShutterText;
